import { call, put, select } from 'redux-saga/effects';
import { setDomainAnalyticData } from '../../../../state/analytic/analyticDomainDataSlice';
import { selectUserCredentials } from '../../../../state/userCredential/userCredentialSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* fetchDomainDataSaga(action) {
    const { range, startDate, endDate } = action.payload || {};
    const { domain } = yield select(selectUserCredentials);
    try {
        const params = { range };
        if (range === 'custom' && startDate && endDate) {
            params.startDate = new Date(startDate).toISOString();
            params.endDate = new Date(endDate).toISOString();
        }
        const { data } = yield call(
            [backendClient, backendClient.get],
            `analytics/domains/${encodeURIComponent(domain)}`,
            { params }
        );
        yield put(setDomainAnalyticData({
            range,
            calls: data?.calls || [],
        }));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to fetch domain analytic data', err?.response?.status, err?.message);
    }
}
